export default {
  workOrderConfigApi: {
    config: {
      typeTree: '/api/workOrderConfig/typeTree',
      addType: '/api/workOrderConfig/addType',
      updateType: '/api/workOrderConfig/updateType',
      delType: '/api/workOrderConfig/delType',
      getTemplateList: '/api/workOrderConfig/getTemplateList',
      saveOrUpdateTemplate: '/api/workOrderConfig/saveOrUpdateTemplate',
      delTemplates: '/api/workOrderConfig/delTemplates',
      getDelayConfig: '/api/workOrderConfig/getDelayConfig',
      saveOrUpdateDelayConfig: '/api/workOrderConfig/saveOrUpdateDelayConfig',
    },
    query: {
      findLastTemplateByTypeIds: '/api/workOrderConfig/findLastTemplateByTypeIds',
      typeData: '/api/workOrderConfig/typeData',
    }
  }
}
